import { atom } from 'recoil'
import { IProjectCheckpointInstance } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import { IProject } from 'screens/Projects/projects.types'

interface IProjectCheckpointInstancesAtom {
  /**
   * Map of project ids and their checkpoint instances
   */
  items: Record<IProject['id'], IProjectCheckpointInstance[]>
}

const projectCheckpointInstancesAtom = atom<IProjectCheckpointInstancesAtom>({
  key: 'project-checkpoint-instances',
  default: { items: {} },
})

export default projectCheckpointInstancesAtom
